<template>
  <v-row no-gutters>
    <v-col cols="12">
      <span>Provider Source Type</span>
    </v-col>
    <v-col cols="12">
      <v-select
        id="ddlProviderSourceType"
        v-model="sourceType"
        :items="providerSourceTypes"
        item-title="text"
        item-value="value"
        variant="solo"
        density="compact"
        placeholder="Select Provider Source Type"
        clearable
        clear-icon="mdi-close"
        color="primary"
        @click:clear="clear"
      >
        <template #item="data">
          <v-list-item
            v-bind="data.props"
            :id="`client-individual-modal--provider-source-type--option-${String(
              data.item.text
            ).replaceAll(' ', '')}`"
          >
            {{ data.item.text }}
          </v-list-item>
        </template>
      </v-select>
    </v-col>
  </v-row>
  <div v-if="displayApi">
    <client-provider-api v-model="apiProvider"></client-provider-api>
  </div>
  <div v-if="displaySftp">
    <client-provider-sftp v-model="sftpProvider"></client-provider-sftp>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { CSBase } from '@complispace/cs-design-system';
import providerSourceType from '../lib/const/providerSourceType';
import ClientProviderSftp from './ClientProviderSftp';
import ClientProviderApi from './ClientProviderApi';

export default {
  name: 'ClientProvider',

  components: {
    ClientProviderSftp,
    ClientProviderApi
  },

  extends: CSBase,
  props: {
    clientSid: { type: String, required: false, default: '' }
  },

  emits: ['clientProviderChanged', 'clientProviderSaved'],

  data() {
    return {
      editMode: { type: String, required: false, default: 'create' },

      providerSourceTypes: [
        {
          text: providerSourceType.SFTP,
          value: providerSourceType.SFTP
        },
        {
          text: providerSourceType.API,
          value: providerSourceType.API
        }
      ],
      sourceType: null,
      apiProvider: { apiKey: '', baseUrl: '', reportSid: '', tenantSid: '' },
      sftpProvider: { sftpPath: '' }
    };
  },

  computed: {
    ...mapGetters({
      clientProviderView: 'clients/clientProviderView'
    }),
    displaySftp() {
      return providerSourceType.SFTP === this.sourceType;
    },
    displayApi() {
      return providerSourceType.API === this.sourceType;
    }
  },

  watch: {
    sourceType() {
      this.updateProvider();
    },
    sftpProvider: {
      handler() {
        this.updateProvider();
      },
      deep: true
    },
    apiProvider: {
      handler() {
        this.updateProvider();
      },
      deep: true
    }
  },

  async mounted() {
    this.initPage(this.clientSid);
  },

  methods: {
    async initPage(clientSid) {
      if (clientSid !== '') {
        this.editMode = 'update';
        await this.fetchClientProvider();
        this.reloadData();
      }
    },
    async fetchClientProvider() {
      try {
        if (this.clientSid) {
          this.setLoading(true);
          await this.$store.dispatch('clients/fetchClientProvider', this.clientSid);
          this.clearLoading();
        }
      } catch (e) {
        this.clearLoading();
        this.clear();
      }
    },
    async reloadData() {
      const newValue = this.clientProviderView || {};
      this.clear();
      this.sourceType = newValue.sourceType || null;
      if (providerSourceType.SFTP === this.sourceType) {
        this.sftpProvider = newValue.clientSftpProvider || {};
      } else if (providerSourceType.API === this.sourceType) {
        this.apiProvider = newValue.clientApiProvider || {};
      }
    },
    clear() {
      this.apiProvider = { apiKey: '', baseUrl: '', reportSid: '', tenantSid: '' };
      this.sftpProvider = { sftpPath: '' };
    },
    updateProvider() {
      const newConfig = { clientSid: this.clientSid, sourceType: this.sourceType };
      if (providerSourceType.SFTP === this.sourceType) {
        newConfig.clientSftpProvider = this.sftpProvider;
      } else if (providerSourceType.API === this.sourceType) {
        newConfig.clientApiProvider = this.apiProvider;
      }
      this.$emit('clientProviderChanged', newConfig);
    }
  }
};
</script>
<style scoped></style>
